export var isSmartPosition = function (position) {
    return typeof position === 'string';
};
